import { render, staticRenderFns } from "./RereviewBatches.vue?vue&type=template&id=ecc27946"
import script from "./RereviewBatches.vue?vue&type=script&lang=js"
export * from "./RereviewBatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports